import { ThemeColorPresetsValue, ThemeSettingsValueProps } from './types';

export const defaultSettings: ThemeSettingsValueProps = {
  themeMode: 'light',
  themeContrast: 'default',
};

export const defaultThemeColorPreset: ThemeColorPresetsValue = 'communicate';
